enum Cookies {
  PWA_NEXT_ENABLED = 'pwa-next-enabled',
  USER_IDENTIFIER_COOKIE_NAME = 'ha_anonymous_id',
  FEATURES = 'ha-feature-flags',
}

export default Cookies;
